module.exports = __webpack_public_path__ + "images/working-in-the-music-industry.jpg?7b6b2";